import axios from "axios";

const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCode";

export const getLogsContent = async (path) => {
  const response = await axios.get(`${api_base_url}/LogsContent`, {
    params: { path },
  });

  return response.data;
};
